import { Component, Input } from '@angular/core';
import { Countries } from '../../../constants/countries.constants';
import { IProtoAddress } from '../../../models/common';
import { Address } from '@lsq-frontend/remote-services/enterprise/common';
import { Utilities } from '../../../utilities/utilities.helper';

// TODO(dmayer): remove the keys with underscores once we figure out the improper camelCasing bug in protobuf-js.
/**
 * @group Companies
 * @component Address
 *
 * @export
 * @class LsqAddressComponent
 * @property {Address} [address] address fields
 * @property {boolean} [singleLine] should it render in a single line
 * @property {boolean} [showCountry] whether or not to show the country
 */
@Component({
    selector: 'lsq-address',
    template: `
        <div *ngIf="!!address" [ngClass]="{ 'is-single-line': singleLine }">
            <span *ngIf="!!address.address1" [ngClass]="{ line: true, 'text-truncate': truncate }">
                {{
                    address.address1 ||
                        address.streetLine_1 ||
                        address.streetLine1 ||
                        address.street
                }},
                <span *ngIf="!!address.address2">
                    {{ address.address2 || address.streetLine_2 || address.streetLine2 }},
                </span>
            </span>
            <div [ngClass]="{ line: true, 'text-truncate': truncate }">
                <span *ngIf="singleLine">&nbsp;</span>
                <span *ngIf="!!address.city">{{ address.city }},</span
                ><!-- prevent whitespace
             --><span *ngIf="address.state && (!address.country || isUsa(address.country))"
                    ><!-- prevent whitespace
                 -->&nbsp;{{ address.state
                    }}<!-- prevent whitespace
                 --><span *ngIf="address.postalCode || address.zipCode">,</span>
                </span>
                <span *ngIf="!!address.postalCode || !!address.zipCode"
                    >&nbsp;{{ address.postalCode || address.zipCode }}</span
                ><!-- prevent whitespace
             --><span *ngIf="showCountry && (address.country || address.countryCode)"
                    >,&nbsp;{{ address.country || address.countryCode }}</span
                >
            </div>
        </div>
    `,
    styleUrls: ['./lsq-address.component.scss']
})
export class LsqAddressComponent {
    @Input() public address: Address & IProtoAddress;
    @Input() public singleLine = false;
    @Input() public truncate = false;
    @Input() public showCountry = false;
    public countries = Countries;
    public isUsa = Utilities.isUsa;
}
